(() => {
    const LOCAL_STORAGE_KEY = 'hoculus-wishlist';
    const headerBadge = document.querySelector('.header__utils-item--wishlist');

    document.body.addEventListener('click', onBodyClick);
    document.addEventListener('hoculus:wishlist-updated', () => {
        onWishlistUpdate();
    });

    document.addEventListener('hoculus:wishlist-cleared', () => {
        onWishlistUpdate();
    });

    function onBodyClick(event) {
        if (event.target.matches('hoculus-wishlist-button')) {
            event.target.toggleWishlist();
        }
    }

    updateWishlistIcon();
    function updateWishlistIcon() {
        const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
        headerBadge.classList.toggle('has-items', wishlist.length > 0);
        headerBadge.setAttribute('data-count', wishlist.length);

        document.querySelectorAll('hoculus-wishlist-button').forEach(button => {
            const isInWishlist = wishlist.some(item => item.variantId === button.dataset.variantId);
            button.querySelector('svg').classList.toggle('is-in-wishlist', isInWishlist);
        });
    }

    function onWishlistUpdate() {
        updateWishlistIcon();
    }

    class WishlistButton extends HTMLElement {
        variantId = this.dataset.variantId;
        productHandle = this.dataset.productHandle;
        hasOnlyDefaultVariant = this.dataset.hasOnlyDefaultVariant === 'true';

        constructor() {
            super();
        }

        toggleWishlist(){
            const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
            if ( wishlist.length && this.variantInWishlist()){
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist.filter(item => item.variantId !== this.variantId)));
            } else {
                wishlist.push({ productHandle: this.productHandle, variantId: this.variantId });
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
            }

            document.dispatchEvent(new CustomEvent('hoculus:wishlist-updated', { detail: { variantId: this.variantId, productHandle: this.productHandle } }));
        }

        variantInWishlist(){
            return (JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || []).find(item => item.variantId === this.variantId) ? true : false;
        }
    }

    class WishlistBanner extends HTMLElement {
        textContents = JSON.parse(this.dataset.text);
        addedText = this.textContents["added-text"];
        removedText = this.textContents["removed-text"];

        constructor() {
            super();
            this.timeout = null;
        }

        connectedCallback() {
            document.addEventListener('hoculus:wishlist-updated', (event) => {
                this.moverWishlistBanner(event.detail.variantId, event.detail.productHandle);
            });
        }

        moverWishlistBanner(variantId, productHandle) {
            const isInWishlist = (JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || []).find(item => item.variantId === variantId) ? true : false;
            isInWishlist ? this.setTextToWishlistBanner(this.addedText, productHandle) : this.setTextToWishlistBanner(this.removedText, productHandle);
        }

        setTextToWishlistBanner(text, productHandle){
            const title = productHandle.replace(/[-0-9]/g, ' ').replace(/\s+/g, ' ').trim();
            const span = this.querySelector('.hoculus-wishlist-banner__content-text span');
            span.textContent = text.replace('[]', title);
            this.classList.add('is-show');

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                this.classList.remove('is-show');
                this.timeout = null;
            }, 2500);
        }
    }

    class WishlistGrid extends HTMLElement {
        gridItemsEl = this.querySelector('[data-grid-items]');
        productsCountEl = this.querySelector('[data-products-count]');
        clearWishlistBtn = this.querySelector('[data-clear-wishlist]');
        addAllBtn = this.querySelector('[data-add-all]');

         constructor() {
            super();
        }

        async connectedCallback() {
            this.onWishlistUpdate();
            document.addEventListener('hoculus:wishlist-updated', this.onWishlistUpdate.bind(this));

            if (this.clearWishlistBtn)
            this.clearWishlistBtn.addEventListener('click', () => {
                this.gridItemsEl.innerHTML = '';
                this.wishlistCount = 0;
                localStorage.removeItem(LOCAL_STORAGE_KEY);
                document.dispatchEvent(new CustomEvent('hoculus:wishlist-cleared'));

                if (this.productsCountEl) {
                    this.setItemsCount();
                }

                if (this.clearWishlistBtn) this.clearWishlistBtn.style.display = 'none';
                if (this.addAllBtn) this.addAllBtn.style.display = 'none';
            });

            this.addAllBtn?.addEventListener('click', this.onAddAll.bind(this));

            const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || null) ?? [];
            while (wishlist.length) {
                const markup = await this.getMarkup(wishlist.splice(0, 4));
                if (!markup) {
                    console.error('Error fetching wishlist items');
                    continue;
                }
                this.gridItemsEl.insertAdjacentHTML('beforeend', markup);
            }
            
            const currentWishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
            Array.from(this.querySelectorAll('hoculus-wishlist-button')).forEach(btn => {
                btn.querySelector('svg')?.classList.toggle(
                    'is-in-wishlist',
                    currentWishlist.some(item => item.variantId === btn.dataset.variantId)
                );
            });

        }


        onWishlistUpdate(event) {
            const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || null) ?? [];
            this.wishlistCount = wishlist.length;
            Array.from(this.querySelectorAll('product-card')).find((card) => card.querySelector('hoculus-wishlist-button').dataset.variantId === event.detail?.variantId)?.remove();

            if (this.productsCountEl) {
                this.setItemsCount();
            }

            if (this.wishlistCount > 0) {
                if (this.clearWishlistBtn) this.clearWishlistBtn.classList.remove('hide');
                if (this.addAllBtn) this.addAllBtn.classList.remove('hide');
            } else {
                if (this.clearWishlistBtn) this.clearWishlistBtn.classList.add('hide');
                if (this.addAllBtn) this.addAllBtn.classList.add('hide');
            }
        }

        async getMarkup(items) {
            return Promise.allSettled(this.wishlistArrayToPromises(items)).then(responses => {
                const fullFilledPromises = responses.filter(res => res.status === 'fulfilled');
                return Promise.all(fullFilledPromises.map(response => response.value.text())).then(markups => markups.join``);
            }).catch(console.error);
        }

        setItemsCount() {
            if (this.wishlistCount === 1) this.productsCountEl.textContent = `${this.wishlistCount} ${this.productsCountEl.dataset.item}`;
            else this.productsCountEl.textContent = `${this.wishlistCount} ${this.productsCountEl.dataset.items}`;
        }

        wishlistArrayToPromises(items) {
            const urls = items.map(item => `/products/${item.productHandle}?variant=${item.variantId}&view=hoculus-product-card`);
            return urls.map(url => fetch(url));
        }

        onAddAll(evt) {
            const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || null) ?? [];

            const formData = {
                items: wishlist.map(item => ({ id: parseInt(item.variantId), quantity: 1 }))
            }

            evt.target.disabled = true;
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.status === 422) {
                    this.displayError(data.message, evt.target);
                    return;
                }
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            }).finally(() => evt.target.disabled = false);
        }


        displayError(message, el) {
            const p = document.createElement('p');
            p.textContent = message;
            (el ?? this).after(p);
            setTimeout(() => {
                p.remove();
            }, 5000);
        }

    }

    customElements.define('hoculus-wishlist-button', WishlistButton);
    customElements.define('hoculus-wishlist-banner', WishlistBanner);
    customElements.define('hoculus-wishlist-grid', WishlistGrid);
})();